export const ticket =
  'https://jlpleisurebenefits.zendesk.com/hc/en-us/categories/200423202';
export const product =
  'https://jlpleisurebenefits.zendesk.com/hc/en-us/articles/360025818334';
